import React, { useState, useEffect } from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";
import { Spinner } from "reactstrap";

const ApexRevenue = ({ dataColors }) => {
  const [series, setSeries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const apexRevenuechartColors = getChartColorsArray(dataColors);

  useEffect(() => {
    const fetchRevenueData = async () => {
      setIsLoading(true);
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const isAdmin = authUser?.HESAP_TURU === 'Admin'; // Admin kontrolü ID: 3

        if (!userId) return;

        // Bulunduğumuz yılın başından itibaren verileri çekiyoruz
        const currentYear = new Date().getFullYear();
        const startDate = `${currentYear}-01-01T00:00:00Z`;

        // Filtre: Admin ise tüm Price verileri, sürücü ise sadece kendi Users_ID'si
        const filterStr = isAdmin 
          ? `$filter=OLUSTURMA_TARIHI ge ${startDate}` 
          : `$filter=KULLANICI_ID eq ${userId} and OLUSTURMA_TARIHI ge ${startDate}`;

        const response = await fetch(
          `https://harmanagelapi.stechomeyazilim.info/ILANLAR?${filterStr}&$select=Price,OLUSTURMA_TARIHI`
        );
        const result = await response.json();

        if (result && result.value) {
          // 12 ay için 0 değerine sahip bir dizi oluşturuyoruz
          const monthlyRevenue = new Array(12).fill(0);

          result.value.forEach(item => {
            if (item.OLUSTURMA_TARIHI && item.Price) {
              const month = new Date(item.OLUSTURMA_TARIHI).getMonth(); // 0-11
              monthlyRevenue[month] += parseFloat(item.Price);
            }
          });

          setSeries([{
            name: isAdmin ? "Toplam Ciro" : "Aylık Kazanç",
            data: monthlyRevenue.map(val => Math.round(val)) // Değerleri yuvarlıyoruz
          }]);
        }
      } catch (error) {
        console.error("Gelir verisi çekilemedi:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRevenueData();
  }, []);

  const options = {
    chart: {
      height: 330,
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "25%",
        borderRadius: 4
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    },
    yaxis: {
      title: { text: "Tutar (TL)" },
      labels: {
        formatter: function (val) {
          return "TL" + val.toLocaleString("tr-TR");
        }
      }
    },
    fill: { opacity: 1 },
    colors: apexRevenuechartColors,
    tooltip: {
      y: {
        formatter: function (val) {
          return "TL" + val.toLocaleString("tr-TR");
        }
      }
    }
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "330px" }}>
          <Spinner color="primary" />
        </div>
      ) : (
        <ReactApexChart options={options} series={series} type="bar" height="330" className="apex-charts" />
      )}
    </React.Fragment>
  )
}

export default ApexRevenue;